export const ProductData = [
    { name: "Main Store", id: 2 },
    { name: "Project Fabrication", id: 4 },
];